import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Button } from './ui/Button';
import { useLanguage } from '../context/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  const scrollToPortfolio = () => {
    document.getElementById('portfolio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="hero" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-slate-950" data-id="element-106">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-107">
        <div className="absolute -top-[20%] -right-[10%] w-[800px] h-[800px] rounded-full bg-cyan-500/10 blur-[120px]" data-id="element-108" />
        <div className="absolute top-[20%] -left-[10%] w-[600px] h-[600px] rounded-full bg-blue-600/10 blur-[100px]" data-id="element-109" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-110">
        <div className="max-w-4xl" data-id="element-111">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-cyan-400 text-sm font-medium mb-8 animate-fade-in-up" data-id="element-112">
            <span className="relative flex h-2 w-2" data-id="element-113">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75" data-id="element-114"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500" data-id="element-115"></span>
            </span>
            {t.hero.badge}
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight leading-[1.1] mb-8" data-id="element-116">
            {t.hero.title} <br data-id="element-117" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500" data-id="element-118">
              {t.hero.titleHighlight}
            </span>
          </h1>

          <p className="text-xl text-slate-400 mb-10 max-w-2xl leading-relaxed" data-id="element-119">
            {t.hero.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-120">
            <Button variant="primary" size="lg" onClick={scrollToContact} className="group" data-id="element-121">
              {t.hero.cta}
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-122" />
            </Button>
            <Button variant="outline" size="lg" onClick={scrollToPortfolio} data-id="element-123">
              {t.hero.ctaSecondary}
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce text-slate-500" data-id="element-124">
        <ChevronDown size={24} data-id="element-125" />
      </div>
    </section>;
}